import React from 'react';
import { Container } from './index.style';

const ScrollSnap = ({ children, disabled, className }) => (
  <Container disabled={disabled} className={className}>
    {children}
  </Container>
);

export default ScrollSnap;